var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "32px",
    viewBox: "0 0 71 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invex_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invex_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    fill: "#F7F7F7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53571429,0 L68.4642857,0 C69.8842857,0 71,1.2 71,2.7 L71,29.3 C71,30.8 69.8842857,32 68.4642857,32 L2.53571429,32 C1.11571429,32 0,30.8 0,29.3 L0,2.7 C0,1.2 1.11571429,0 2.53571429,0",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Banco",
    fontFamily: "Avenir-Book, Avenir",
    fontSize: 8,
    fontWeight: "normal",
    letterSpacing: -0.133333333,
    fill: "#080206"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46.2133333,
    y: 22
  }, "Banco")), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,11.5 L5.6,11.5 L5.6,8.9 L2.7,8.9 L2.7,11.5 Z M2.7,21.6 L5.5,21.6 L5.5,13.1 L2.7,13.1 L2.7,21.6 Z M28.9,16.4 C29,15.8 29.2,14.7 30.5,14.7 C31.8,14.7 32.1,15.7 32.1,16.4 L28.9,16.4 Z M41.5,17.3 C41.5,17.3 44,13.4 44.2,13.1 L41.1,13.1 C41.1,13.2 39.7,15.8 39.7,15.8 C39.7,15.8 38.4,13.2 38.4,13.1 L35,13.1 C35.2,13.4 37.7,17.3 37.7,17.3 L36,19.7 C33.5,19.8 32.6,19.8 31.9,19.8 L31.7,19.8 C30.1,19.8 29.1,19.4 28.9,18.2 L28.9,18.1 L34.9,18.1 L34.9,17.6 C34.9,16.1 34.5,12.8 30.6,12.8 C27.8,12.8 26,14.5 26,17.3 C26,20 28,21.8 31,21.8 L33.8,21.8 L36.5,21.7 L38.1,21.7 C38.2,21.6 39.6,18.9 39.6,18.9 C39.6,18.9 40.8,21.6 40.9,21.7 L44.3,21.7 C44.2,21.4 41.5,17.3 41.5,17.3 M23.5,13.1 L21.7,19.2 L21.6,19.5 C21.6,19.5 19.8,13.2 19.7,13.1 L16.7,13.1 C16.8,13.3 19.8,21.5 19.9,21.6 L23.2,21.6 C23.2,21.5 26.3,13.3 26.3,13.1 L23.5,13.1 Z M13.6,13.1 L10.1,13.1 L7.4,13.1 L7.4,21.6 L10.3,21.6 L10.3,15.1 L12.3,15.1 C13.7,15.1 13.7,16.3 13.7,17.5 L13.7,21.6 L16.5,21.6 L16.5,17.5 C16.5,13.8 15.4,13.1 13.6,13.1",
    id: "Shape",
    fill: "#A41D2F",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvex);
export default __webpack_public_path__ + "static/media/invex.3ec14c732c3ef228ee0303a3cd2cfca4.svg";
export { ForwardRef as ReactComponent };